import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ccontainer } from '../Ccontainer';
import { Clogo } from '../Clogo';
import { Ctext } from '../Ctext';
export function InitialAllocationBadge(): ReactElement {
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
            marginTop: '32px',
        }}>
        <Ctext size={19} weight={FontWeight.Regular} color={ColorType.White} opacity={1} style={{ letterSpacing: '1.1px' }}>
          Initial Allocation:
        </Ctext>
        <Ccontainer backgroundColor={ColorType.Black} backgroundOpacity={0.2} borderColor={ColorType.Accent} borderOpacity={0.6} glow={3} radius={20} padding="4px 18px" style={{
            boxShadow: 'rgb(102 254 193 / 17%) 0px 1px 0px 0px inset, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.6) 1px 2px 5px 0px inset, rgb(102 254 193 / 15%) 0x -1px 0px 0px inset'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '4px',
        }}>
            <Ctext size={17.6} weight={FontWeight.Bold} color={ColorType.Accent} opacity={1}>
              100
            </Ctext>
            <div style={{ marginLeft: '2px' }}>
              <Clogo dataElScope="Cauthmodal/InitialAllocationBadge" size={19.2} withText={false}/>
            </div>
          </div>
        </Ccontainer>
      </div>
    );
}
